var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mb-2":""},domProps:{"innerHTML":_vm._s(_vm.description)}})
}
var staticRenderFns = []

export { render, staticRenderFns }